import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const blogCategories = [
  { id: 'todos', label: 'Todos' },
  { id: 'saude-mulher', label: 'Saúde da Mulher' },
  { id: 'gestacao', label: 'Gestação' },
  { id: 'pre-natal', label: 'Pré-Natal' },
  { id: 'ginecologia', label: 'Ginecologia' },
  { id: 'menopausa', label: 'Menopausa' },
  { id: 'estetica-intima', label: 'Estética Íntima' },
];

const blogPosts = [
  {
    id: 1,
    title: 'Menopausa sem tabus: o que toda mulher precisa saber',
    category: 'menopausa',
    excerpt: 'Entenda as mudanças do corpo, os sintomas mais comuns e as opções de tratamento disponíveis para viver essa fase com qualidade de vida.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20woman%20in%20soft%20beige%20silk%2C%20serene%20expression%2C%20warm%20natural%20lighting%2C%20minimalist%20photography%20style%2C%20art%20direction%20with%20organic%20textures%2C%20feminine%20wellness%20concept%2C%20premium%20aesthetic&width=800&height=500&seq=femme-blog-01&orientation=landscape',
    date: '15 de Julho, 2026',
    readTime: '8 min de leitura',
  },
  {
    id: 2,
    title: 'Pré-natal humanizado: a importância do acolhimento na gestação',
    category: 'pre-natal',
    excerpt: 'Como um acompanhamento pré-natal personalizado pode transformar a experiência da gravidez, garantindo saúde física e emocional para mãe e bebê.',
    image: 'https://readdy.ai/api/search-image?query=Soft%20elegant%20pregnancy%20photography%2C%20glowing%20expectant%20mother%20in%20cream%20dress%2C%20warm%20natural%20light%20through%20window%2C%20minimalist%20aesthetic%2C%20feminine%20and%20gentle%20mood%2C%20editorial%20style&width=800&height=500&seq=femme-blog-02&orientation=landscape',
    date: '08 de Julho, 2026',
    readTime: '6 min de leitura',
  },
  {
    id: 3,
    title: 'Candidíase de repetição: causas, prevenção e tratamento',
    category: 'saude-mulher',
    excerpt: 'A relação entre alimentação, estilo de vida e infecções vaginais recorrentes. Saiba como prevenir e quando buscar ajuda médica.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20wellness%20still%20life%2C%20white%20ceramic%2C%20fresh%20green%20herbs%2C%20soft%20beige%20linen%2C%20natural%20lighting%2C%20elegant%20composition%2C%20feminine%20health%20concept%20photography&width=800&height=500&seq=femme-blog-03&orientation=landscape',
    date: '01 de Julho, 2026',
    readTime: '7 min de leitura',
  },
  {
    id: 4,
    title: 'Ginecologia regenerativa: o futuro da saúde íntima feminina',
    category: 'ginecologia',
    excerpt: 'Tecnologias como laser e radiofrequência estão revolucionando o tratamento de condições ginecológicas. Conheça os benefícios da medicina regenerativa.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20medical%20technology%20aesthetic%2C%20soft%20rose%20and%20cream%20tones%2C%20abstract%20feminine%20forms%2C%20clean%20minimal%20composition%2C%20sophisticated%20healthcare%20concept%2C%20elegant%20lighting&width=800&height=500&seq=femme-blog-04&orientation=landscape',
    date: '24 de Junho, 2026',
    readTime: '9 min de leitura',
  },
  {
    id: 5,
    title: 'Check-up ginecológico: por que fazer anualmente?',
    category: 'saude-mulher',
    excerpt: 'A importância dos exames de rotina para prevenção e diagnóstico precoce. Um guia completo sobre o que esperar da sua consulta anual.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20clean%20medical%20consultation%20concept%2C%20soft%20cream%20and%20beige%20tones%2C%20feminine%20healthcare%20photography%2C%20minimalist%20styling%2C%20warm%20natural%20light%2C%20sophisticated%20wellness%20aesthetic&width=800&height=500&seq=femme-blog-05&orientation=landscape',
    date: '17 de Junho, 2026',
    readTime: '5 min de leitura',
  },
  {
    id: 6,
    title: 'Estética íntima: o que é e para quem é indicada',
    category: 'estetica-intima',
    excerpt: 'Desmistificamos os procedimentos estéticos íntimos, suas indicações, contraindicações e resultados esperados. Informação clara e sem tabus.',
    image: 'https://readdy.ai/api/search-image?query=Soft%20elegant%20spa%20concept%2C%20rose%20petals%20on%20cream%20marble%2C%20minimalist%20luxury%20aesthetic%2C%20warm%20ambient%20lighting%2C%20feminine%20and%20sophisticated%20atmosphere%2C%20clean%20composition&width=800&height=500&seq=femme-blog-06&orientation=landscape',
    date: '10 de Junho, 2026',
    readTime: '7 min de leitura',
  },
];

export default function Blog() {
  const [activeCategory, setActiveCategory] = useState('todos');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredPosts = activeCategory === 'todos'
    ? blogPosts
    : blogPosts.filter((p) => p.category === activeCategory);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        {/* Page Header */}
        <section className="relative pt-32 pb-16 md:pt-40 md:pb-20 bg-background-100 overflow-hidden">
          <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary-400 via-transparent to-transparent" />
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16 text-center">
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              className="text-xs tracking-[0.2em] uppercase text-primary-400 font-label"
            >
              Conteúdo
            </motion.span>
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="font-heading text-4xl md:text-6xl lg:text-7xl text-foreground-950 mt-4 leading-[1.05]"
            >
              Blog da<br />
              <span className="italic font-light">Femme Vie.</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="max-w-[680px] mx-auto mt-6 text-foreground-600 text-base leading-relaxed"
            >
              Informação de qualidade sobre saúde feminina, escrita por especialistas. Nosso compromisso é educar, inspirar e empoderar mulheres em todas as fases da vida.
            </motion.p>
          </div>
        </section>

        {/* Categories */}
        <section className="relative bg-background-50 pt-12 pb-6">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="flex flex-wrap items-center gap-2 justify-center">
              {blogCategories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`px-5 py-2.5 rounded-full text-xs tracking-[0.06em] uppercase font-label whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-900'
                  }`}
                >
                  {cat.label}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Grid */}
        <section className="relative bg-background-50 py-16 md:py-24">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post, index) => (
                <motion.article
                  key={post.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.06 * index }}
                  whileHover={{ y: -4 }}
                  className="group cursor-pointer transition-all duration-400"
                >
                  <div className="relative rounded-lg overflow-hidden aspect-[16/10] mb-5">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                    />
                  </div>
                  <div className="flex items-center gap-3 text-xs text-foreground-500 font-label mb-3">
                    <span className="px-2.5 py-1 rounded-full bg-primary-50 text-primary-500 text-[11px] tracking-[0.05em] uppercase">
                      {blogCategories.find((c) => c.id === post.category)?.label}
                    </span>
                    <span>{post.date}</span>
                    <span>·</span>
                    <span>{post.readTime}</span>
                  </div>
                  <h3 className="font-heading text-xl text-foreground-950 leading-tight group-hover:text-primary-500 transition-colors duration-300">
                    {post.title}
                  </h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                    {post.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1.5 mt-4 text-xs tracking-[0.06em] uppercase text-primary-500 font-label group-hover:gap-2 transition-all duration-300 whitespace-nowrap">
                    Ler mais
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </motion.article>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}